import { processGeojson } from 'kepler.gl/processors';
import { wrapTo, removeDataset } from 'kepler.gl/actions';
import { addDataToMap } from "kepler.gl/actions";

const ROUTE_COVERAGE_GEO_JSON_PATH = "/all_temporal_data.geojson";

export const fetchAndProcessRouteCoverageGeoJSON = async (setLayerDataState, dispatch, store) => {
    let geojson;
    try {
        const response = await fetch(ROUTE_COVERAGE_GEO_JSON_PATH);
        if (!response.ok) {
            console.error('Invalid Route Coverage GeoJSON data', response.statusText);
        }

        // Parse the JSON data
        geojson = await response.json();
        if (!geojson || !geojson.features) {
            console.error('Invalid Route Coverage GeoJSON data');
        }

        console.log("Route Coverage GeoJSON", geojson);
    } catch(error) {
        console.error('Error fetching zone GeoJSON data:', error);
    }

    setLayerDataState((prev) => ({ ...prev, routeCoverageGeoJSON: geojson }));

    console.log("Sujeet Route Coverage ProcessedGeoJson : ", processGeojson(geojson));

    dispatch(wrapTo('evidence', removeDataset('routecoverage')));

    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "RouteCoverage", id: "routecoverage" },
                    data: processGeojson(geojson)
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
                visState: {
                    interactionConfig: {
                        geocoder: {
                            enabled: true
                        }
                    },
                    layers: [
                        {
                            "id": "routecoverage",
                            "type": "geojson",
                            "config": {
                                "dataId": "routecoverage",
                                "columnMode": "geojson",
                                "label": "BLR Route Coverage",
                                "color": [
                                    248,
                                    149,
                                    112
                                ],
                                "highlightColor": [
                                    252,
                                    242,
                                    26,
                                    255
                                ],
                                "columns": {
                                    "geojson": "_geojson"
                                },
                                "isVisible": false,
                                "visConfig": {
                                    "opacity": 0.8,
                                    "strokeOpacity": 0.8,
                                    "thickness": 2,
                                    "strokeColor": [
                                        47,
                                        197,
                                        204
                                    ],
                                    "colorRange": {
                                        "name": "Global Warming",
                                        "type": "sequential",
                                        "category": "Uber",
                                        "colors": [
                                        "#4C0035",
                                        "#880030",
                                        "#B72F15",
                                        "#D6610A",
                                        "#EF9100",
                                        "#FFC300"
                                        ]
                                    },
                                    "strokeColorRange": {
                                        "name": "Global Warming",
                                        "type": "sequential",
                                        "category": "Uber",
                                        "colors": [
                                        "#4C0035",
                                        "#880030",
                                        "#B72F15",
                                        "#D6610A",
                                        "#EF9100",
                                        "#FFC300"
                                        ]
                                    },
                                    "radius": 10,
                                    "sizeRange": [
                                        0,
                                        10
                                    ],
                                    "radiusRange": [
                                        0,
                                        50
                                    ],
                                    "heightRange": [
                                        0,
                                        500
                                    ],
                                    "elevationScale": 5,
                                    "stroked": true,
                                    "filled": false,
                                    "enable3d": false,
                                    "wireframe": false,
                                    "fixedHeight": false
                                },
                                "hidden": false,
                                "textLabel": [
                                    {
                                        "field": null,
                                        "color": [
                                        255,
                                        255,
                                        255
                                        ],
                                        "size": 18,
                                        "offset": [
                                        0,
                                        0
                                        ],
                                        "anchor": "start",
                                        "alignment": "center",
                                        "outlineWidth": 0,
                                        "outlineColor": [
                                        255,
                                        0,
                                        0,
                                        255
                                        ],
                                        "background": false,
                                        "backgroundColor": [
                                        0,
                                        0,
                                        200,
                                        255
                                        ]
                                    }
                                ]
                            },
                            "visualChannels": {
                                "colorField": null,
                                "colorScale": "quantile",
                                "strokeColorField": null,
                                "strokeColorScale": "quantile",
                                "sizeField": null,
                                "sizeScale": "linear",
                                "heightField": null,
                                "heightScale": "linear",
                                "radiusField": null,
                                "radiusScale": "linear"
                            }
                        }
                    ]
                }
            }
        })
    );

    console.log("Current Map Route Coverage Configuration:", store.getState());

    console.log("Sujeet Route Coverage useEffect end", geojson);
};